import React from 'react';
import './service-detail.css';

function ServiceDetail({
  tag,
  title,
  intro,
  heroImage,
  gallery,
  paragraphs,
  listTitle,
  listItems,
  otherServices,
}) {
  return (
    <section className="tc-project-style1 detail-style2 header">
      <div className="main-info">
        <div className="container">
          <div className="tags mb-50">
            <a href="/innerpages/services"> Services </a>
            <a href="#"> {tag} </a>
          </div>
          <h1 className="title"> {title} </h1>
          <div className="text color-666 mt-30">{intro}</div>
        </div>
      </div>

      <div className="main-img" style={{ height: "700px" }}>
  <img
    src={heroImage}
    alt={title}
    className="img-cover"
    data-speed="1.25"
  />
</div>

      <div className="description">
        <div className="container overview-container">
          <h3
            className="sub-title fsz-45 mb-40 wow fadeInUp slow"
            data-wow-delay="0.2s"
          >
            Overview
          </h3>

          <div className="overview-body">
            {paragraphs.map((para, i) =>
              i === 0 ? (
                <p key={i} className="lead-text wow fadeInUp slow" data-wow-delay="0.2s">
                  {para}
                </p>
              ) : (
                <p
                  key={i}
                  className="text color-666 wow fadeInUp slow"
                  data-wow-delay="0.2s"
                >
                  {para}
                </p>
              )
            )}
          </div>
        </div>

        {gallery && gallery.length > 0 && (
          <div className="container gallery-section">
            <h3
              className="sub-title fsz-45 mb-60 wow fadeInUp slow"
              data-wow-delay="0.2s"
            >
              Gallery
            </h3>
            <div className="gallery-grid wow fadeInUp slow" data-wow-delay="0.2s">
              {gallery.map((img, i) => (
                <a
                  href={img}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gallery-item"
                  key={i}
                >
                  <img src={img} alt={`${title} ${i + 1}`} className="img-cover" />
                </a>
              ))}
            </div>
          </div>
        )}

        <div className="challenge pt-100">
          <div className="container">
            <h3
              className="sub-title fsz-45 mb-60 wow fadeInUp slow"
              data-wow-delay="0.2s"
            >
              {listTitle}
            </h3>
            <ul
              className="checklist-grid fsz-18 color-666 wow fadeInUp slow"
              data-wow-delay="0.2s"
            >
              {listItems.map((item, i) => (
                <li key={i}>
                  <span className="check-icon bg-orange1 text-white">
                    <i className="ti-check"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="text-center mt-100">
          <a
            href="/innerpages/contact"
            className="butn rounded-pill hover-bg-black bg-orange1 text-white"
          >
            <span>
              Discuss Your Project
              <i className="small ms-1 ti-arrow-top-right"></i>
            </span>
          </a>
        </div>

        {otherServices && otherServices.length > 0 && (
          <div className="container mt-100">
            <h3
              className="sub-title fsz-45 mb-60 wow fadeInUp slow"
              data-wow-delay="0.2s"
            >
              Explore Other Services
            </h3>
            <div className="other-services-grid mb-50">
              {otherServices.map((s, i) => (
                <a href={s.link} className="other-service-card" key={i}>
                  {s.title}
                  <i className="ti-arrow-top-right color-orange1"></i>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default ServiceDetail;
